import { Navbar } from "../components/Navbar";
import { MobileCalculateur } from "../components/MobileCalculateur";
import { SEO } from "../components/SEO";

export default function CalculateurPage() {
  return (
    <div className="bg-[#0a0a0a] min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <SEO
        path="/calculateur"
        title="Calculateur de Terrasse en Bambou — Estimez vos Matériaux"
        description="Calculez gratuitement les matériaux nécessaires pour votre terrasse en bambou : lames, lambourdes, clips. Choisissez dimensions, forme et finition. Outil professionnel PROBWA."
      />
      <Navbar />
      <main className="pt-16 md:pt-20">
        {/* Compact header */}
        <div className="text-center py-3 md:py-4">
          <h1
            className="text-lg md:text-2xl font-bold text-[#E8E8E8]"
            data-testid="calculateur-title"
          >
            Configurateur de <span className="text-[#8BC34A]">terrasse</span>
          </h1>
          <p className="text-[11px] md:text-xs text-white/70 mt-0.5">
            Choisissez vos dimensions, forme et finition
          </p>
        </div>
        <MobileCalculateur />
      </main>
    </div>
  );
}
